module.exports = __webpack_public_path__ + "img/sulv_5.892f4527.jpg";